module.exports = __webpack_public_path__ + "static/media/img1-1.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/biomasa/img1-1.png
// module id = 1264
// module chunks = 3